import { Suspense, lazy } from 'react';
import { Navigate } from 'react-router-dom';
import { RouteObject } from 'react-router';

import SidebarLayout from 'src/layouts/SidebarLayout';
import BaseLayout from 'src/layouts/BaseLayout';
import PrivetRoute from './PrivetRoute';
import SuspenseLoader from 'src/components/SuspenseLoader';
import Login from './pages/Login/login';
import UserList from './pages/UserList';
const Loader = (Component) => (props) =>
  (
    <Suspense fallback={<SuspenseLoader />}>
      <Component {...props} />
    </Suspense>
  );
const Podcast = Loader(lazy(() => import('src/pages/Podcast/PodcastList')));
const PodcastCreate = Loader(
  lazy(() => import('src/pages/Podcast/PodcastCreate'))
);
const PodcastView = Loader(lazy(() => import('src/pages/Podcast/PodcastView')));
const PodcastUpdate = Loader(
  lazy(() => import('src/pages/Podcast/PodcastUpdate'))
);
const Messenger = Loader(lazy(() => import('src/pages/Messenger')));


const routes: RouteObject[] = [
  {
    path: '*',
    element: <Navigate to={'/'} replace />
  },
  {
    path: '/',
    element: <Login />
  },
  {
    path: 'dashboards',
    element: <PrivetRoute element={ <SidebarLayout />} />,
    children: [
      {
        path: 'messenger',
        element: <PrivetRoute element={<Messenger />} />
      },
      {
        path: 'podcast',
        children: [
          {
            path: 'list',
            element: <PrivetRoute element={<Podcast />} />
          },
          {
            path: 'create',
            element: <PrivetRoute element={<PodcastCreate />} />
          },
          {
            path: 'view/:id',
            element: <PrivetRoute element={<PodcastView />} />
          },
          {
            path: 'update/:id',
            element: <PrivetRoute element={<PodcastUpdate />} />
          }
        ]
      },
      {
        path: 'userlist',
        element: <PrivetRoute element={<UserList />} />
      }
    ]
  }
];

export default routes;
